<template>
  <div class="accomodations-values">
    <!-- TITULO -->
    <div class="form--title">
      <PmwHeading size="paragraph-80" weight="weight-light">
        Acréscimo por pax adicional
      </PmwHeading>

      <PmwParagraph class="form--subtitle" size="paragraph-40">
        Configure por tipo de ocupação se desejar um valor diferente do padrão
        apenas para esta tarifa.
      </PmwParagraph>
    </div>

    <!-- BOTÃO DE MOSTRAS INPUTS -->
    <div v-if="!showInputs" class="form--row">
      <PmwButton
        :hasIcon="true"
        layout="outline"
        variation="blue-100"
        class="form--button"
        @click="showInputsHandler"
      >
        Adicionar pax
      </PmwButton>
    </div>

    <!-- INPUTS DOS CAMPOS DE NOITE GRATIS -->
    <div v-if="showInputs && fluctuationData.diferenciaisPax" class="form--row">
      <AdditionalPaxInputs
        :boardData="fluctuationData.diferenciaisPax"
        :maxChildren="maxChildren"
        :maxAdults="maxAdults"
        @closeInputs="removeAccomodationsHandler"
      />
    </div>
  </div>
</template>

<script>
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import AdditionalPaxInputs from './AdditionalPaxInputs'

export default {
  name: 'AdditionalPax',
  components: {
    PmwHeading,
    PmwButton,
    AdditionalPaxInputs,
    PmwParagraph
  },

  props: {
    fluctuationData: {
      type: Object,
      default: () => ({})
    },

    hotelRoomsData: {
      type: Array,
      default: () => []
    },

    isOpen: {
      type: Boolean,
      default: false
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      showInputs: false,

      paxData: [],

      maxAdults: null,

      maxChildren: null
    }
  },

  watch: {
    async showInputs(newVal) {
      if (newVal) {
        if (!this.hotelRoomsData?.length) {
          this.$emit('load-hotel-rooms-data')
        }

        if (!this.paxData?.length) {
          const { data } = await this.$hotel.getHotelPax(this.$route.params.id)
          this.paxData = data
        }

        await this.createPaxObjects()
      }
    },

    isOpen: {
      handler(newVal) {
        if (
          newVal &&
          this.fluctuationData.diferenciaisPax &&
          this.fluctuationData.diferenciaisPax?.length
        ) {
          this.showInputs = true
        }
      },
      immediate: true
    }
  },

  created() {
    if (
      !this.fluctuationData.diferenciaisPax &&
      this.fluctuationData.diferenciaisPax?.length
    ) {
      this.showInputs = true
    }
  },

  methods: {
    async showInputsHandler() {
      this.showInputs = true
    },

    getMaxOccupants() {
      /* Encontrar o maior valor de maximoCriancas de todos os quartos */
      const maxMaximoCriancas = this.hotelRoomsData.reduce(
        (maxCriancas, quarto) => Math.max(maxCriancas, quarto.maximoCriancas),
        0
      )

      /* Encontrar o maior valor entre maximoAdultos - baseOcupantes para cada hotel */
      const maxMaximoAdultosBaseOcupantesPorHotel = this.hotelRoomsData.reduce(
        (maxVals, quarto) => {
          const chaveHotel = quarto.codigoHotel.toString()
          const diff = quarto.maximoAdultos - quarto.baseOcupantes

          maxVals[chaveHotel] = Math.max(maxVals[chaveHotel] || 0, diff)

          return maxVals
        },
        {}
      )

      /* Encontrar o maior valor entre maximoAdultos - baseOcupantes para todos os hotéis */
      const maximoAdultosBaseOcupantes = Object.values(
        maxMaximoAdultosBaseOcupantesPorHotel
      ).reduce((maxVal, val) => Math.max(maxVal, val), 0)

      this.maxAdults = maximoAdultosBaseOcupantes
      this.maxChildren = maxMaximoCriancas
    },

    /**
     * Inicializa a criação de objetos Pax, configurando estruturas de dados necessárias
     * e iterando sobre o array paxData.
     */
    createPaxObjects() {
      if (!this.fluctuationData.diferenciaisPax?.length) {
        this.fluctuationData.diferenciaisPax = []
      }

      this.getMaxOccupants()

      const itens = []
      this.paxData.forEach((itemPax) => {
        this.generateOcupantes(itens, itemPax, this.maxAdults, 10)
        this.generateOcupantes(itens, itemPax, this.maxChildren, 8)
      })

      this.fluctuationData.diferenciaisPax = itens

      this.fluctuationData.diferenciaisPax.sort((a, b) => {
        return a.codigoPax - b.codigoPax
      })
    },

    /**
     * Gera ocupantes com base nos parâmetros fornecidos e os adiciona ao array itens.
     *
     * @param {Array} itens - Um array para armazenar os ocupantes gerados.
     * @param {Object} itemPax - Os dados do Pax atual sendo processado.
     * @param {Number} maxCount - A contagem máxima de ocupantes (adultos ou crianças).
     * @param {Number} tipoPax - O tipo de Pax (por exemplo, 10 para adultos, 8 para crianças).
     */
    generateOcupantes(itens, itemPax, maxCount, tipoPax) {
      for (let i = 1; i <= maxCount && itemPax.tipoPax === tipoPax; i++) {
        const generatedOcupante = {
          nomePax: itemPax.nome,
          codigoPax: itemPax.codigo,
          tipoValor: 2,
          ocupanteAdicional: i,
          valorAdicional: null
        }

        const backendOccupant = this.findbackendOccupant(generatedOcupante)

        const finalOcupante = backendOccupant
          ? { ...generatedOcupante, ...backendOccupant }
          : generatedOcupante

        itens.push(finalOcupante)
      }
    },

    /**
     * Verifica se já existe o ocupante dentro do array fluctuationData.diferenciaisPax
     *
     * @param {Object} generatedOcupante - O ocupante gerado para o qual o ocupante backend correspondente está sendo procurado.
     * @returns {Object|null} - Ocupante backend correspondente ou null se não encontrado.
     */
    findbackendOccupant(generatedOcupante) {
      return this.fluctuationData.diferenciaisPax.find(
        (backendItem) =>
          backendItem.codigoPax === generatedOcupante.codigoPax &&
          backendItem.ocupanteAdicional === generatedOcupante.ocupanteAdicional
      )
    },

    removeAccomodationsHandler() {
      this.showInputs = false
      this.$emit('close')
      this.fluctuationData.diferenciaisPax = []
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  &--button {
    max-width: 265px;
    width: 265px;
  }

  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 24px;
    margin-bottom: 32px;
  }

  &--title {
    margin-bottom: 24px;
    position: relative;
  }

  &--subtitle {
    font-size: font-size('size-small');
    font-weight: font-weight('weight-normal');
    color: pmw-colors(grey-80);
    line-height: 21px;
  }
}
</style>
